<style>
	.bg343 {
		background-color: #fff;width:100%; 
	}
 
 
.draw-enter-active, .draw-leave-active {
     transition: opacity 1s;
}
.draw-enter, .draw-leave-to /* .fade-leave-active below version 2.1.8 */ {
     opacity: 0;
}
.top_area{width:100%;height:4vw;position:fixed;top:1vw;left:0; }
.top_area img{display:block;float:left;height:4vw; }
.tabbar5{width:84vw;height:4vw;background:url(../../assets/images/tabbar_bg.png) center center; border-radius:.5vw;
float:left;margin-left:2.5vw;background-size:105% 105%; }
.tabbar5 span{display:block;float:left;line-height:4vw;font-size:1.4vw;}
.tabbar5 span.pos{  padding:0 1vw;}
.tabbar5 span.floder{ color:#666;}
 
.tabbar5 span.rights{background:url(../../assets/images/right.png) no-repeat;width:2vw;
height:4vw;background-position:center center;background-size:2vw;}

.interact_right{width:64vw;height: 45vw;background-color: #fffff9;margin: 0;padding: 0;overflow: hidden;margin-top:6vw;float: left;
border: #e3e3e3 solid 1px;box-sizing: border-box; border-left: 0;}
.interact_right_top{width: 60vw;height: 3vw;margin-top: 2vw;margin-left: 2vw;}
.interact_right_top span.interact_right_span{display: block;float: left;line-height: 3vw;height: 3vw;text-align: left;font-size: 1.2vw;color: #000;}
.interact_right_top img{display: block;width: 1.8vw;height: 1.8vw;float: left;margin-top: .6vw;padding-right: 1vw;}
.interact_right_top .interact_right_btn1{float: right;background-color: #f90;height: 3vw;line-height: 3vw;padding: 0 1vw;color: #fff;font-size: 1.1vw;}
.interact_right_top .interact_right_btn2{float: right;background-color: #3465ff;height: 3vw;line-height: 3vw;padding: 0 1vw;margin-left: 1vw;color: #fff;font-size: 1.1vw;}
.interact_right_top .interact_right_btn3{float: right;background-color: #32AD37;height: 3vw;line-height: 3vw;padding: 0 1vw;margin-left: 1vw;color: #fff;font-size: 1.1vw;}
.interact_right_box3{width: 60vw;height: 24.5vw;border: #e8f1f4 solid 1px;margin: 0 auto;margin-top: 2vw;border-bottom: 0;}
.interact_right_box3 ul{margin: 0;padding: 0;list-style: none;}
.interact_right_box3 ul li{width: 100%;height: 3.5vw;border-bottom:#e8f1f4 solid 1px ;box-sizing: border-box;}
.interact_right_box3 ul li span{display: block;line-height: 3.5vw;float: left;text-align: center;border-left:#e8f1f4 solid 1px;box-sizing: border-box;}
.interact_right_box3 ul li span.a1{width: 7%;border-left: 0;}
.interact_right_box3 ul li span.a2{width: 8%;}
.interact_right_box3 ul li span.a333{width: 63%;}
.interact_right_box3 ul li span.a4{width: 8%;}
.interact_right_box3 ul li span.a5{width: 20%;}
.interact_right_box3 ul li span.a6{width: 7%;}
.interact_right_box3 ul li span.a7{width: 10%;}
.a2_div{float: left;border-left:#e8f1f4 solid 1px;box-sizing: border-box;width: 8%;height: 3.5vw;position: relative;}
.a2_div span{display: block;width: 1.5vw;height:1.5vw;margin:  0 auto;position: absolute;left:1.6vw;border:#bfbfbf solid 1px;top: 1vw;
}
.a2_div img{position: absolute;width: 2vw;height: 2vw;left: 1.4vw;top: .5vw;}
.interact_right_box3 ul li span.a3311{width:63%;color: #3465ff;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;text-align: left;
padding: 0 1%;}
.a4_div{float: left;border-left:#e8f1f4 solid 1px;box-sizing: border-box;width: 8%;height: 3.5vw;}
.a4_div_box{display: block;padding: 0;height:1.5vw;margin:  0 auto;border:#c00 solid 1px;line-height: 1.5vw;float: none;
text-align: center;width: 3vw;margin-top: 1vw;color: #c00;}
.a4_div_box2{display: block;padding: 0;height:1.5vw;margin:  0 auto;border:#999 solid 1px;line-height: 1.5vw;float: none;
text-align: center;width: 3vw;margin-top: 1vw;color: #999;}

.interact_right_box3 ul li span.a66{width:7%;color: #3465ff;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;text-align: center;
padding: 0 1%;}
.a7_div{float: left;border-left:#e8f1f4 solid 1px;box-sizing: border-box;width: 10%;height: 3.5vw;}
.a7_div span.b1{color: #3465ff;width: 45%;float: left;border: 0;text-align: right;}
.a7_div span.b2{color: #3465ff;width: 45%;float: right;border: 0;text-align: left;}
.interact_pages{width: 100%;height: 5vw;vertical-align: middle;text-align: center;}
.interact_pages img{width: 2vw;height: 2vw;vertical-align: middle;}
.interact_pages span{line-height: 5vw;vertical-align: middle;font-size: 1.4vw;padding: 0 1vw;font-weight: bold;}
.interact_pages span.on{color: #3465ff;}



.interact_array{width: 60vw;height: 7vw;border-top: #ddd solid 1px;}
.interact_array span.arr1{display: block;float: left;padding: 0 1vw;height: 4vw;line-height: 4vw;margin-top: 1.5vw;margin-left: 5vw;color: #000;}
.interact_array span.arr2{display: block;float: left;padding: 0 1vw;height: 4vw;line-height: 4vw;margin-top: 1.5vw;color: #000;}
.interact_array input{width: 10vw;height: 2.8vw;line-height: 2.8vw;border: #ddd solid 1px;outline: none;float: left;margin-top: 2.1vw;
padding: 0 1vw;font-size: 1.2vw;color: #3465ff;}
.interact_array button.arr3{display: block;background-color: #3465ff;color: #fff;border: 0;outline: none;height: 2.8vw;float: left;
margin-left: 1vw;font-size: 1.1vw;padding: 0 2vw;margin-top: 2.1vw;}
.interact_array button.arr4{display: block;background-color: #32ad37;color: #fff;border: 0;outline: none;height: 2.8vw;float: left;
margin-left: 1vw;font-size: 1.1vw;padding: 0 2vw;margin-top: 2.1vw;}
.interact_array b{color: #f00;font-size: 1.2vw;}
</style>
<template>
	<div class="bg343">

         
	     <u_center></u_center>
	     <interact :main="main" :sub="sub" :title="title"></interact>
	     <div class="interact_right">
	     	<div class="interact_right_top">
		     	<span class="interact_right_span">Q&A列表</span>
		     	<div class="interact_right_btn2" @click="qd_add()"><img src="../../../static/images/add.png">新增Q&A</div>
		     	<div class="interact_right_btn3">复制Q&A链接</div>
	        </div>
	        <div class="interact_right_box3">
	        	<ul>
	        		<li><span class="a1">ID</span>
	        		 
	        			<span class="a333">标题</span>
	        			 
	        			<span class="a5">发布时间</span>
	        		 
	        			<span class="a7">操作</span>
	        		</li>
	        		<li><span class="a1">635</span>
	        			<span class="a3311">标题标题标题标题标题标题标题</span> 
	        			<span class="a5">2022-05-01 12:01:23</span>
	        			<div class="a7_div"><span class="b1">修改</span><span class="b2">删除</span></div>
	        		</li>
	        		<li><span class="a1">635</span>
	        			<span class="a3311">标题标题标题标题标题标题标题</span> 
	        			<span class="a5">2022-05-01 12:01:23</span>
	        			<div class="a7_div"><span class="b1">修改</span><span class="b2">删除</span></div>
	        		</li>
	        		<li><span class="a1">635</span>
	        			<span class="a3311">标题标题标题标题标题标题标题</span> 
	        			<span class="a5">2022-05-01 12:01:23</span>
	        			<div class="a7_div"><span class="b1">修改</span><span class="b2">删除</span></div>
	        		</li>
	        		<li><span class="a1">635</span>
	        			<span class="a3311">标题标题标题标题标题标题标题</span> 
	        			<span class="a5">2022-05-01 12:01:23</span>
	        			<div class="a7_div"><span class="b1">修改</span><span class="b2">删除</span></div>
	        		</li>
	        		<li><span class="a1">635</span>
	        			<span class="a3311">标题标题标题标题标题标题标题</span> 
	        			<span class="a5">2022-05-01 12:01:23</span>
	        			<div class="a7_div"><span class="b1">修改</span><span class="b2">删除</span></div>
	        		</li>
	        		<li><span class="a1">635</span>
	        			<span class="a3311">标题标题标题标题标题标题标题</span> 
	        			<span class="a5">2022-05-01 12:01:23</span>
	        			<div class="a7_div"><span class="b1">修改</span><span class="b2">删除</span></div>
	        		</li>
	        		 
	        	</ul>
	        </div>
            <div class="interact_pages">
	        		<img src="../../assets/images/pre2.png">
	        		<span>1</span><span>2</span><span class="on">3</span><span>4</span><span>5</span>
	        		<img src="../../assets/images/next1.png">
	        </div>
		 </div>
	</div>
</template>
<script>
import u_center from '@/components/u_center.vue'; 
import interact from '@/components/interact.vue'; 
	export default {
	    components: {
		  u_center,
		  interact
	    },
		data() {
			return {
				token:"",
				main:3,
				sub:"",
				title:"Q&A管理"
			}
		},
		mounted() {
		      var token= localStorage.getItem("token");
			  if(!token){
					 self.$router.push("/");  
			  }else{
			      self.token=token;
				  
			  } 

		},
		methods: {
			qd_add(){
                   this.$router.push("/qa_add");  
			},
			 add_template(){	 
              if(!this.sign_selected){
              	  this.$toast.center('请选择签名');
              	  return;
              }
		      let self=this;
			  self.$loading('提交中...');
		      axios.post(this.$api+'/message/add_template', {
					   token:self.token,
					   type:self.type,
					   content:self.content,
					   signname:self.signname
		      }).then(function (response) {  
			      let data=response.data;
				  if(data.state==1){
				             self.$toast.center('添加成功，请等待审核');	
                             setTimeout(function(){
								        self.$loading.close();
										self.back();
					         },1000);				  
					 		 
				  }else if(data.state==3){                
					 self.$router.push("/");  		 
				  }else{
				     self.$loading.close();
				     self.$toast.center(data.msg);	
				  } 
		      }).catch(function (error) {
			         
		      });
		  },
		},watch:{
			   content(){
			     this.current_length=  this.$refs.count.value.length; 		      
			     this.count=Math.ceil(this.current_length/70);
			   }
              
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/interact/qa.vue